import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import {
  fetchAccountList,
  fetchAllStations,
} from '../../redux/slices/RevenueManagementStationSlice';
import AutoCompleteSelectField from '../../shared-components/auto-complete-select-field/AutoCompleteSelectField';
// import PageTitle from '../../shared-components/page-title/PageTitle';

import AccountRevenueSharing from './components/AccountRevenueSharing';
import ManagementAccountRevenue from './components/ManageAccountRevenue';
import ManagementStationRevenue from './components/ManageStationRevenue';
import StationRevenueSharing from './components/StationRevneuSharing';

/**
 * User Management page function component
 */
function RevenueManagement() {
  const { t } = useTranslation('revenue');
  const { page } = useParams();
  const dispatch = useAppDispatch();
  const [openTab, setOpenTab] = useState<number>();
  const [currentPage, setCurrentPage] = useState<string>('account');
  const [selectedAccountId, setSelectedAccountId] = useState<string | number>('');

  const {
    accountList,
    page: revenueStationPage,
    limit,
  } = useAppSelector((state) => state.revenueStation);

  /**
   * Change the page function
   * @param data
   */

  /**
   * Function to change account Id filter
   * @param name
   * @param onChangeValue
   */
  const handleChangeAccountId = (name: string, onChangeValue: string | number) => {
    setSelectedAccountId(onChangeValue);
    dispatch(
      fetchAllStations({
        page: revenueStationPage,
        limit,
        accountCustomId: onChangeValue.toString(),
      }),
    );
  };

  useEffect(() => {
    if (accountList.length === 0 && currentPage === 'station') {
      dispatch(fetchAccountList());
    }
  }, [currentPage]);
  useEffect(() => {
    setOpenTab(page === 'sharing' ? 0 : 1);
  }, [page]);
  return (
    <div style={{ width: '100%', height: '100%' }}>
      <div className="container revenue-body">
        {false && openTab === 1 && currentPage === 'station' && (
          <div className="revenue-toggle-wrap">
            <AutoCompleteSelectField
              name=""
              inputLabel=""
              selectedValue={selectedAccountId}
              placeholder={t('accountID')}
              onChangeValue={handleChangeAccountId}
              options={accountList}
            />
          </div>
        )}
        <div className="table-content">
          {openTab === 0 && (
            <div className="table-content">
              {currentPage === 'account' && (
                <AccountRevenueSharing currentPage={currentPage} setCurrentPage={setCurrentPage} />
              )}
              {currentPage === 'station' && (
                <StationRevenueSharing currentPage={currentPage} setCurrentPage={setCurrentPage} />
              )}
            </div>
          )}
          {openTab === 1 && (
            <div className="table-content">
              {currentPage === 'account' && (
                <ManagementAccountRevenue
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                />
              )}
              {currentPage === 'station' && (
                <ManagementStationRevenue
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  selectedAccountId={selectedAccountId}
                />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default RevenueManagement;
